// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   firebase: {
//     apiKey: 'xx',
//     authDomain: 'proc-cert.firebaseapp.com',
//     databaseURL: 'https://proc-cert.firebaseio.com',
//     projectId: 'proc-cert',
//     storageBucket: 'proc-cert.appspot.com',
//     messagingSenderId: '706214752101'
//   }
// };

// Firebase connection to vea-multiplex-temp/firestore/databases
export const environment = {
  firebase: {
    apiKey: "AIzaSyAoSZ0YPffg9eoXgpu9bx-bmsF6RG6rzuQ",
    authDomain: "vea-multiplex-temp.firebaseapp.com",
    databaseURL: "https://vea-multiplex-temp-default-rtdb.firebaseio.com",
    projectId: "vea-multiplex-temp",
    storageBucket: "vea-multiplex-temp.firebasestorage.app",
    messagingSenderId: "441451168479",
    appId: "1:441451168479:web:2660280a5681b0457bdf6a",
    measurementId: "G-42004FY2B0"
  },
  production: false,
  isAltDomain: true, // for alternate domain, should be true
  remoteRedirectUrl: 'https://eqao-mpt-qc.vretta.com' // is Alt domain, should point towards MAIN domain, and vice versa.
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
